module.exports = "/images/howto_pic.png?3f50314b2c8cfefe16e6b8c5003b94be";